import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class LeadService {
    static getLeads(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`leads?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.lead.createdOn = parseDate(x.lead.createdOn);
                x.lead.updatedOn = parseDate(x.lead.updatedOn);
            });
            return w;
        }));
    }
    static fetchLead(oid) {
        return BaseService.get(`leads/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            return x;
        }));
    }
    static saveLead(dto) {
        return BaseService.save(`leads`, dto);
    }
    static deleteLead(oid) {
        return BaseService.delete(`leads/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Comments
    // ----------------------------------------------------------------------
    static getLeadComments(leadId) {
        return BaseService.get(`lead-comments/${leadId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveLeadComment(dto) {
        return BaseService.post(`lead-comments`, dto);
    }
    static deleteLeadComment(oid) {
        return BaseService.delete(`lead-comments/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Channels
    // ----------------------------------------------------------------------
    static getLeadChannels(companyId) {
        return BaseService.get(`lead-channels/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveLeadChannel(dto) {
        return BaseService.post(`lead-channels`, dto);
    }
    static deleteLeadChannel(oid) {
        return BaseService.delete(`lead-channels/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchLeadCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`leads-combo/${selfId}?search=${qs}`);
    }
}
